// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_FmvyG","foot_link":"index_foot_link_cX9aW","list":"index_list_tmaKE","link":"index_link_eg6iS","copyright":"index_copyright_mrLzW"};